//# sourceMappingURL=extra.mjs.map
/// <reference types="./extra.d.mts" />
import * as $event from "../../../../redraw/redraw/event.mjs";
import * as $attribute from "../../../../redraw_dom/redraw/dom/attribute.mjs";
import * as $mouse from "../../../../redraw_dom/redraw/dom/event/mouse.mjs";
import * as $wheel from "../../../../redraw_dom/redraw/dom/event/wheel.mjs";
import * as $events from "../../../../redraw_dom/redraw/dom/events.mjs";

export const none = $events.none;

export function on_click(handler) {
  return $events.on_click(
    (event) => {
      handler(event);
      return undefined;
    },
  );
}

export function on_aux_click(handler) {
  return $events.on_aux_click(
    (event) => {
      handler(event);
      return undefined;
    },
  );
}

export function on_wheel(handler) {
  return $events.on_wheel(
    (event) => {
      handler(event);
      return undefined;
    },
  );
}

export function on_submit(handler) {
  return $events.on_submit(
    (event) => {
      handler(event);
      return undefined;
    },
  );
}

export function on_change(handler) {
  return $events.on_click(
    (event) => {
      handler(event);
      return undefined;
    },
  );
}

export function on_drag_enter(handler) {
  return $events.on_drag_enter(
    (event) => {
      handler(event);
      return undefined;
    },
  );
}

export function on_drag_start(handler) {
  return $events.on_drag_start(
    (event) => {
      handler(event);
      return undefined;
    },
  );
}

export function on_drag_end(handler) {
  return $events.on_drag_end(
    (event) => {
      handler(event);
      return undefined;
    },
  );
}

export function on_drag_over(handler) {
  return $events.on_drag_over(
    (event) => {
      handler(event);
      return undefined;
    },
  );
}

export function on_drag_leave(handler) {
  return $events.on_drag_leave(
    (event) => {
      handler(event);
      return undefined;
    },
  );
}

export function on_drop(handler) {
  return $events.on_drop(
    (event) => {
      handler(event);
      return undefined;
    },
  );
}

export function on_input(handler) {
  return $events.on_input(
    (event) => {
      handler(event);
      return undefined;
    },
  );
}

export function on_key_down(handler) {
  return $events.on_key_down(
    (event) => {
      handler(event);
      return undefined;
    },
  );
}
